import {Component, Input, OnChanges, SimpleChanges} from "@angular/core";
import {Device} from "../device";
import {DeviceModel} from "../device-model";
import {DeviceService} from "../device.service";

@Component({
	selector: "device-display",
	template: `
		<div *ngIf="device && deviceModel" class="devicedisplay_container">
			<image-container
				class="devicedisplay_image"
				[width]="70"
				[height]="70"
				[src]="deviceModel.imageURL"
				[alt]="deviceModel.displayName"></image-container>
			<div class="devicedisplay_info">
				<p class="devicedisplay_name">{{device.name}}</p>
				<p class="devicedisplay_model">{{deviceModel.make}} {{deviceModel.name}}</p>
				<p class="devicedisplay_serial">{{deviceModel.displaySerialType}}: {{device.displaySerial}}</p>
			</div>
		</div>
	`,
})
export class DeviceDisplayComponent implements OnChanges {
	@Input() deviceID: number;
	device: Device;
	deviceModel: DeviceModel;

	constructor(private deviceService: DeviceService) {}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.deviceID) {
			this.deviceService.getDevice(this.deviceID, false, true).subscribe(device => {
				this.device = device;
				this.deviceService.getDeviceModels().subscribe(deviceModels => {
					this.deviceModel = deviceModels.find(model => model.id === this.device.modelID);
				});
			});
		}
	}
}
